import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useDroneAreasContext } from 'src/contexts/drone-areas.context';
import { IDroneAreas } from 'src/models/drone-areas.model';
import Lang from 'src/libraries/language';
import { getDroneAreasStatus } from 'src/selectors/drone-areas.selector';
import { actionTypes } from 'src/ducks/drone-areas.duck';
import style from '../drone-areas-list/drone-areas-list.module.scss';

type IProp = {
  data: IDroneAreas;
};

const DroneAreasDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useDroneAreasContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getDroneAreasStatus(
    state,
    actionTypes.DRONE_AREAS_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.droneAreasId) {
      const response = await actions.itemDELETE(data.droneAreasId);

      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_DRONE_AREAS_DELETE_SUCCESS, data.SensitiveCityLocation)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_DRONE_AREAS}
      content={
        <div className={style.content}>
          {Lang.formatString(Lang.MSG_CONFIRM_DELETE, data.SensitiveCityLocation)}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default DroneAreasDelete;
